/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchParcelResultDto } from '../../models/search-parcel-result-dto';

export interface SearchForParcelByViewPfi$Params {
  viewPfi: string;
}

export function searchForParcelByViewPfi(
  http: HttpClient,
  rootUrl: string,
  params: SearchForParcelByViewPfi$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchParcelResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForParcelByViewPfi.PATH, 'get');
  if (params) {
    rb.path('viewPfi', params.viewPfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchParcelResultDto>;
      }),
    );
}

searchForParcelByViewPfi.PATH = '/search/parcel/view_pfi/{viewPfi}';
